module.exports = __webpack_public_path__ + "img/scene-shop.01658ef2.png";